import {
  Button,
  ButtonGroup,
  Stack,
  Icon,
  Wrap,
  WrapItem,
} from '@chakra-ui/react';
import { getNearbyButtonIcon } from '~/constants';
import { useAppStore } from '~/store/useAppStore';
import { useFilters } from '~/hooks/useFilters';
import { useHomesStore } from '~/store/useHomesStore';
import { getFilterArrayValues } from '@habity/services';
import { NearbyType } from '@habity/types';
import { NEARBY } from '@habity/constants';

export const Nearby = ({
  ignoreSearch = false,
}: {
  ignoreSearch?: boolean;
}) => {
  const filters = useHomesStore((state) => state.filters);
  const isMobile = useAppStore((state) => state.isMobile);
  const { performSearch } = useFilters();
  const { nearby } = filters || {};

  const onToggle = (values: NearbyType) => {
    const newNearby = getFilterArrayValues(values, nearby);
    performSearch({ filters: { nearby: newNearby }, ignoreSearch });
  };

  return (
    <Stack spacing="2">
      <ButtonGroup>
        <Wrap>
          {NEARBY
            .toSorted((a,b) => a.title.localeCompare(b.title))
            .map((b) => (
            <WrapItem key={b.title}>
              <Button
                w="full"
                size="sm"
                variant="outline"
                borderColor="blackAlpha.400"
                onClick={() => onToggle(b.key)}
                leftIcon={<Icon as={getNearbyButtonIcon(b.key)} />}
                isActive={nearby?.includes(b.key)}
                _active={{
                  backgroundColor: 'blackAlpha.50',
                  borderColor: "black",
                  borderWidth: "2px",
                }}
              >
                {b.title}
              </Button>
            </WrapItem>
          ))}
        </Wrap>
      </ButtonGroup>
    </Stack>
  );
};
